module.exports = __webpack_public_path__ + "static/media/Bronzeportal.66481391.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/Bronzeportal.jpg
// module id = 755
// module chunks = 0